module.exports = __webpack_public_path__ + "img/21ne.b244248e.svg";